import { UrlMatcher, UrlSegment } from '@angular/router';

import { environment } from '../../environments/environment';
import { createExternalRedirectGuard } from '@app/routes/guards/external-redirect.guard';

/**
 * Matches /newsearch and everything under it (/newsearch/:stateId/:countyId,
 * etc.) so the route below can hand off to Oa.Web's LegacySearchRedirectController,
 * which resolves the legacy state/county FIPS segments and 301s to the Next.js site.
 */
export const newSearchMatcher: UrlMatcher = (segments: UrlSegment[]) => {
  if (segments.length > 0 && segments[0].path === 'newsearch') {
    return { consumed: segments };
  }
  return null;
};

export const legacySearchRedirectGuard = createExternalRedirectGuard(environment.oaWebUrl);
